import { render, staticRenderFns } from "./PricingTableDesktopDetail.vue?vue&type=template&id=e5c64722&scoped=true&"
import script from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"
export * from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableDesktopDetail.vue?vue&type=style&index=0&id=e5c64722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c64722",
  null
  
)

export default component.exports